<div class="relative">
  <div *ngFor="let step of steps; let i = index" [@stepperFadeInOut]="currentStep === i ? 'active' : 'inactive'">
    <ng-container [ngTemplateOutlet]="step"></ng-container>
  </div>
</div>
